import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Button, ProgressLoader } from "../Elements";
import { useLoading } from "../../../hooks/useLoading";
import { ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import MaterailTable from "../Elements/MaterialTable";
import { changeIntegrationLoadingOnReport } from "../../../store/slices/orderReportSlice";
import { FaEllipsisV } from "react-icons/fa";
import ConfirmationModal from "../ConfirmationModal"
import commonNetwork from "../../../common/api/commonNetwork";
import { orderStatusIds, transactionTypes } from "../../../common/helpers/paymentStatusFields";
import { toast } from "react-toastify";
import { Link, useNavigate } from 'react-router-dom';
import PaymentSlipModal from "../PaymentSlipModal";
import { formatCurrency, formatDateOnFront } from "../../../lib/helpers";
import HtmlTooltip from "../HtmlTooltilp";
import { PublishedWithChanges, Cancel, AssignmentReturn, OpenInNew, FileDownload, Receipt, Description } from "@mui/icons-material";
import { generateUUID } from "../../../common/helpers/globalHelpers";
import { integrationRequestTypes, openFormByParameter, openFormOperationType, postMessageTypes } from "../../../constants/postMessageFileds";
import { AUTH_TOKEN } from "../../../constants/storageKeys";
import IntegrationResultModal from "../IntegrationResultModal";
import StatusBox from "../Elements/StatusBox";
import StatusModal from "../Elements/StatusModal";
import appHelpers from "../../../common/helpers/appHelpers";
import { postWebViewMessage } from "../../../common/helpers/messageHelper";
import { getNavigationUrl } from "../../../common/helpers/navigationHelpers";
import { exportExcelHelper } from "../../../common/helpers/exportExcelHelper";
import { getStatusDescHelper } from "../../../common/helpers/getStatusDescHelper";
import { getSendTypeDescHelper } from "../../../common/helpers/getSendTypeDescHelper";
import { getCardOwnerAllDescHelper } from "../../../common/helpers/getCardOwnerAllDescHelper";
import { buttonTexts } from "../../../constants/texts/buttonTexts";
import { muiMenuStyles } from "../../../constants/muiMenuStyles";
import paymentApi from "../../../common/api/paymentApi";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import { isUserAuthorizeToMenu } from "../../../common/helpers/authorizationHelper";
import { UserOperationTypes } from "../../../common/types/AuthorizationProps";
import RefundModal from "./RefundModal";

export default function ReportTable({ formFilterRef, showTableDetail, getHeadCells, reportTableRef }) {
  const classes = muiMenuStyles();

  const { firmInformations } = useRecoilValue(tenantState);
  const { licenseKey, taxCode } = firmInformations;

  const confirmModalRef = useRef();
  const resultStatusModalRef = useRef();
  const refundModalRef = useRef();

  const [anchorEl, setAnchorEl] = useState(null);
  const integratrionResultModalRef = useRef();
  const isopenMenu = Boolean(anchorEl);
  const [dropdownMenuId, setDropdownMenuId] = useState("");
  const [dropdownAllValues, setDropdownAllValues] = useState("");
  const [integrationKeyMatch, setIntegrationKeyMatch] = useState("");

  const [operationsLoading, setOperationsLoadng] = useState(false);
  const [integrationResultModalVisible, setIntegrationResultModalVisible] = useState(false);
  const paymentSlipModalRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const {
    reports,
    isFetching,
    isError,
    isloadingIntegration,
    integrationKey,
    integrationResults,
    isfetchComplete
  } = useSelector((state) => state.orderReport);

  const loading = useLoading(isFetching);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    dispatch(changeIntegrationLoadingOnReport(false));
  }, []);

  useEffect(() => {
    controlIntegrationComplete();
  }, [integrationKey]);
  useEffect(() => {
    getHeadCells(headCells)
  }, [])


  const controlIntegrationComplete = () => {
    if (integrationKey == integrationKeyMatch && integrationKeyMatch.length > 0) { // aktarılan ödemeler tamamlandı, başarılı olayını kontrol et
      setIntegrationKeyMatch("");
      dispatch(changeIntegrationLoadingOnReport(false));
      setIntegrationResultModalVisible(true);
      integratrionResultModalRef.current.showMessage(integrationResults);

      if (formFilterRef && formFilterRef.current) {
        formFilterRef.current.submitform();
      }
    }
  }

  const handleClickMenu = (event, row) => {
    setDropdownAllValues(row);
    setDropdownMenuId(row.id);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onCancelPaymentClick = () => {

    setAnchorEl(null);

    confirmModalRef.current.showConfirm({
      title: "Uyarı!",
      contentText: "Ödeme iptal edilecek. Onaylıyor musunuz?",
      confirmText: "Onayla",
      cancelText: "İptal",
      confirmCallBack: () => onCancelPaymentConfirm()
    });
  }

  const onCancelPaymentConfirm = async () => {
    confirmModalRef.current.hideModal();
    setOperationsLoadng(true);
    const index = reports.findIndex(w => w.id == dropdownMenuId);
    var row = reports[index];
    const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
    var params = {
      TransactionId: row.transactionId
    }

    const { isSuccess, errorMessage, data } = await paymentApi.post("/Payment/cancel", params, apiParams);

    setOperationsLoadng(false);

    var resultModalValues = {
      title: "Ödeme İptali",
      content: "",
      isSuccess: false
    }
    if (isSuccess) {
      if (data.status == true) {

        resultModalValues.content = "Ödeme başarılı bir şekilde iptal edildi."
        resultModalValues.isSuccess = true;

        if (formFilterRef && formFilterRef.current) {
          formFilterRef.current.submitform();
        }
      } else {
        resultModalValues.content = data.errorCode + " " + data.errorMessage;
      }

    } else {
      resultModalValues.content = errorMessage
    }
    resultStatusModalRef.current.openModal(resultModalValues);
  }

  const onRefundPaymentClick = () => {
    const index = reports.findIndex(w => w.id == dropdownMenuId);
    var row = reports[index];
    refundModalRef.current.showRefund({
      amount: row.lastAmount,
      inputAmount: row.lastAmount,
      orderCode: row.transactionId,
      currency: row.currencySymbol,
      confirmCallBack: (inputAmount) => onRefundPaymentConfirm(inputAmount)
    });

    setAnchorEl(null);
  }

  const onRefundPaymentConfirm = async (inputAmount) => {
    setOperationsLoadng(true);
    refundModalRef.current.hideModal();

    const index = reports.findIndex(w => w.id == dropdownMenuId);
    var row = reports[index];
    const apiParams = { licenseKey: licenseKey, taxCode: taxCode };

    const numericAmount = parseFloat(String(inputAmount).replace(/,/g, "")) || 0; 

    const formattedAmount = numericAmount.toFixed(2).replace(".", "");


    var params = {
      TransactionId: row.transactionId,
      Amount: formattedAmount
    };

    const { isSuccess, errorMessage, data } = await paymentApi.post("/Payment/refund", params, apiParams);

    setOperationsLoadng(false);

    var resultModalValues = {
      title: "Ödeme İadesi",
      content: "",
      isSuccess: false
    }

    if (isSuccess) {

      if (data.status) {
        resultModalValues.content = "Ödeme başarılı bir şekilde iade edildi.";
        resultModalValues.isSuccess = true;
        if (formFilterRef && formFilterRef.current) {
          formFilterRef.current.submitform();
        }
      } else {
        resultModalValues.content = data.errorCode + " " + data.errorMessage;
      }

    } else {
      resultModalValues.content = errorMessage;
    }

    resultStatusModalRef.current.openModal(resultModalValues);
  }
  const onCreateSlipClick = () => {


    paymentSlipModalRef.current.showPaymentSlip({
      orderId: dropdownMenuId
    });
    setAnchorEl(null);
  }
  const onDownloadSlipClick = () => {
    paymentSlipModalRef.current.downloadPaymentSlip({
      orderId: dropdownMenuId,
      orderCode: dropdownAllValues.transactionId
    });
    setAnchorEl(null);
  }

  const onIntegrationClick = () => {
    setAnchorEl(null);
    confirmModalRef.current.showConfirm({
      title: "Uyarı!",
      contentText: "Ödeme aktarılacak. Onaylıyor musunuz?",
      confirmText: "Onayla",
      cancelText: "İptal",
      confirmCallBack: () => onIntegrationClickConfirm("deneme")
    });
  }

  const onIntegrationClickConfirm = async (deneme) => {

    var list_for_integration = [];
    dispatch(changeIntegrationLoadingOnReport(true));

    var row = dropdownAllValues;

    var params = [];
    list_for_integration.push({
      orderId: row.id,
      OrderDate: row.orderDate,
      Ordercode: row.transactionId,
      Customername: row.customerName,
      customerCode: row.customerCode,
      Lastamount: row.lastAmount
    });
    params.push({
      OrderId: row.id,
      VpId: row.vpid,
      Synccustomercode: row.synccustomercode || -1,
      Customerid: row.customerid || 0
    });

    const { isSuccess, data, errorMessage } = await commonNetwork.post("/integration/getErpParameters", params);

    if (isSuccess) {

      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        var index = list_for_integration.findIndex(w => w.orderId == element.orderId);

        for (const key in element) {
          list_for_integration[index][key] = element[key];
        }
      }
      onIntegrationPostConfirm(list_for_integration);

    } else {
      dispatch(changeIntegrationLoadingOnReport(false));
      toast.error("Ödeme aktarılırken hata meydana geldi. Lütfen yetkili ile iletişime geçin.");
    }
  }

  const onIntegrationPostConfirm = (list_for_integration) => {
    var body = JSON.stringify(list_for_integration);
    var token = localStorage.getItem(AUTH_TOKEN);
    var guid = generateUUID();
    setIntegrationKeyMatch(guid);
    var messageBody = {
      requestType: postMessageTypes.singleIntegration,
      requestBody: body,
      requestDetailType: integrationRequestTypes.creditCard,
      messageGuid: guid,
      accessToken: token,
      serviceUrl: process.env.REACT_APP_BASE_URL + "/api/v1"
    };
    postWebViewMessage(JSON.stringify(messageBody));
  }

  function isOrderCancellable() {
    const status = dropdownAllValues.orderStatus;
    const transactionType = dropdownAllValues.transactionType;

    const row = reports.find(w => w.id == dropdownMenuId);

    if (!row) return false;

    if (status == orderStatusIds.success && transactionType == transactionTypes.order) {
      return true;
    }
    else if (
      status == orderStatusIds.success &&
      transactionType == transactionTypes.refund &&
      parseFloat(row.firstAmount) !== parseFloat(row.lastAmount) &&
      parseFloat(row.lastAmount) !== 0
    ) {
      return true;
    }

    return false;
  }

  function isOrderInSameDay() {

    return dropdownAllValues.isCancellable == 1
  }
  function isIntegrationActive() {
    var status = dropdownAllValues.syncStatus;

    if (dropdownAllValues.isTest) {
      return false;
    }
    if (status != true) {
      return true;
    }
    return false;
  }

  const openFastPaymentForm = () => {

    var serial = dropdownAllValues.erpdocumentid;
    var documentId = serial;
    var netsisvalues = [];

    netsisvalues.push(documentId);

    var params = {
      formId: "6",
      logicalRef: "15",
      modeType: openFormOperationType.view,
      values: JSON.stringify(netsisvalues)
    }
    var messageBody = {
      requestType: postMessageTypes.openFormByParameter,
      requestBody: JSON.stringify(params)
    };
    openFormByParameter(messageBody);
  }

  const openDocumentFromErp = () => {
    var platform = appHelpers.getPlatform();
    var params = {
      formId: "510",
      logicalRef: dropdownAllValues.erpdocumentid,
      modeType: openFormOperationType.view
    }
    if (platform == "NETSIS") {
      const isReceipt = dropdownAllValues.synctypeid == 2 ? true : false;
      if (dropdownAllValues.synctypeid == 4) {
        openFastPaymentForm();
      } else
        if (isReceipt) {
          var serial = dropdownAllValues.erpdocumentserialcode;
          var documentId = dropdownAllValues.erpdocumentid;
          var netsisvalues = [];
          netsisvalues.push(serial + "");
          netsisvalues.push(documentId + "");

          params = {
            formId: "11",
            logicalRef: "2",
            modeType: openFormOperationType.view,
            values: JSON.stringify(netsisvalues)
          }
        } else {
          var serial = dropdownAllValues.erpdocumentserialcode;
          var documentId = dropdownAllValues.erpdocumentid;
          var netsisvalues = [];

          netsisvalues.push(dropdownAllValues.orderdatestr);
          netsisvalues.push("G");
          netsisvalues.push(dropdownAllValues.erpbankcode);
          // netsisvalues.push("alici2");
          params = {
            formId: "6",
            logicalRef: "2",
            modeType: openFormOperationType.view,
            values: JSON.stringify(netsisvalues)
          }
        }
    }

    var messageBody = {
      requestType: postMessageTypes.openFormByParameter,
      requestBody: JSON.stringify(params)
    };
    openFormByParameter(messageBody);
  }

  function getOrderStatusInfo(status, transactiontype, firstAmount, lastAmount) {
    var { desc, statusType } = getStatusDescHelper(status, transactiontype, firstAmount, lastAmount);
    return <StatusBox content={desc} statusType={statusType} />
  }

  const DropdownMenu = ({ row }) => {
    const isextraItems = isOrderCancellable();
    const isIntegratActive = isIntegrationActive();
    const isSameDay = isOrderInSameDay();
    const platform = appHelpers.getPlatform();

    return (
      <Menu
        id="report-operations"
        anchorEl={anchorEl}
        open={isopenMenu}
        onClose={handleClose}
        classes={{
          paper: classes.paper,
        }}
      >
        {isextraItems ? (<MenuItem onClick={() => {

          onCreateSlipClick()
        }}>
          <ListItemIcon>
            <Description fontSize="small" />
          </ListItemIcon>

          Dekont Görüntüle
        </MenuItem>) : null}

        {isextraItems ? (<MenuItem onClick={() => {

          onDownloadSlipClick()
        }}>
          <ListItemIcon>
            <FileDownload fontSize="small" />
          </ListItemIcon>

          Dekont İndir
        </MenuItem>) : null}
        <MenuItem component={Link} to={getNavigationUrl("/odeme-detayi/" + dropdownAllValues.transactionId)} >
          <ListItemIcon>
            <Receipt fontSize="small" />

          </ListItemIcon>
          Detay Göster
        </MenuItem>
        {isextraItems ? (
          (isIntegratActive && platform != "web") ? (
            <MenuItem onClick={() => {
              onIntegrationClick()
            }}>
              <ListItemIcon>
                <PublishedWithChanges fontSize="small" />
              </ListItemIcon>
              Fiş Oluştur
            </MenuItem>
          ) : null
        ) : null}
        {(isextraItems && isSameDay && isUserAuthorizeToMenu({ authorizationTypes: [UserOperationTypes["Ödeme İptali"]] })) ? (
          <MenuItem onClick={() => {
            onCancelPaymentClick(row.id)
          }}>
            <ListItemIcon>
              <Cancel fontSize="small" />
            </ListItemIcon>
            İptal
          </MenuItem>
        ) : null}
        {(isextraItems && isSameDay != true && isUserAuthorizeToMenu({ authorizationTypes: [UserOperationTypes["Ödeme İadesi"]] })) ? (
          <MenuItem onClick={() => {

            onRefundPaymentClick(row)
          }}>
            <ListItemIcon>
              <AssignmentReturn fontSize="small" />
            </ListItemIcon>
            İade
          </MenuItem>
        ) : null}
        {(dropdownAllValues.erpdocumentid > 0 && platform != "web") ? (
          <MenuItem onClick={() => {

            openDocumentFromErp()
          }}>
            <ListItemIcon>
              <OpenInNew fontSize="small" />
            </ListItemIcon>
            Fiş İncele
          </MenuItem>
        ) : null}
      </Menu>
    );
  }

  const headCells = [
    {
      id: 'operations',
      numeric: false,
      label: 'İşlemler',
      exceptToExcel: true,
      isRender: true,
      bodyClasName: "",
      disableSortIcon: true,
      renderRow: (row) => {

        return (
          <div className="flex flex-row justify-around items-center ">
            <a id="report-operations-a"
              aria-controls={isopenMenu ? 'report-operations' : undefined}
              aria-haspopup="true"
              aria-expanded={isopenMenu ? 'true' : undefined}
              className="cursor-pointer"
              onClick={(event) => handleClickMenu(event, row)}
            >
              <FaEllipsisV
                className="block sm:block h-3 w-3 font-light ml-1"
              />
            </a>
            <DropdownMenu row={row}>
            </DropdownMenu>
          </div>
        );

      }
    },
    {
      id: 'orderDate',
      numeric: true,
      disablePadding: false,
      label: 'Ödeme Tarihi',
      className: "min-w-[150px]",
      isRender: true,
      colWidth: 25, // For excel
      renderRow: (row) => {
        return (
          <div className="">
            {formatDateOnFront(row.orderDate)}
          </div>
        );
      }
    },
    {
      id: 'customerName',
      numeric: true,
      disablePadding: false,
      label: 'Cari Hesap Ünvan',
      className: "min-w-[360px]",
      colWidth: 40, // For excel
      maxLength: 50
    },
    {
      id: 'firstAmount',
      numeric: true,
      disablePadding: false,
      label: 'Tutar',
      className: "min-w-[140px]",
      isMoney: true,
      maxLength: 15,
      colWidth: 20, // For excel
      isRender: true,
      renderRow: (row) => {
        return (
          <>
            {formatCurrency(parseFloat(row.firstAmount)) + (row.currencySymbol == null || undefined ? "₺" : row.currencySymbol)}
          </>
        )
      }
    },
    {
      id: 'installment',
      numeric: false,
      disablePadding: false,
      label: 'Taksit',
      className: "min-w-[100px]",
      isMoney: false,
      maxLength: 12,
      isRender: true,
      renderRow: (row) => {
        return (
          <div className="">
            {row.installment === 0 ||
              row.installment === 1 || row.installment === null
              ? "Peşin"
              : row.installment + " Taksit"}
          </div>
        );
      }
    },
    {
      id: 'orderStatus',
      numeric: true,
      disablePadding: false,
      label: 'Ödeme Durumu',
      className: "min-w-[150px]",
      isRender: true,
      colWidth: 20, // For excel
      renderRow: (row) => {
        const { className, desc } = getOrderStatusInfo(row.orderStatus, row.transactionType);
        if (row.orderStatus === orderStatusIds.error) {
          return (
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit">Hata Detayı</Typography>
                  <label className="font-bold">Hata Kodu: </label>  {row.errorCode}
                  <br />
                  <label className="font-bold">Hata Mesajı: </label>  {row.errorDesc}
                  {row.errorDesc2 ? (
                    <>
                      <br />
                      <label className="font-bold">Hata Açıklaması: </label>  {row.errorDesc2}
                    </>
                  ) : null}

                </React.Fragment>
              }
            >
              {getOrderStatusInfo(row.orderStatus, row.transactionType, row.firstAmount, row.lastAmount)}

            </HtmlTooltip>
          );
        }
        return getOrderStatusInfo(row.orderStatus, row.transactionType, row.firstAmount, row.lastAmount);
      }
    },
    {
      id: 'id',
      numeric: false,
      disablePadding: true,
      label: 'ID',
      isprimary: true,
      className: "min-w-[80px]",
      colWidth: 10, // For excel
      hide: true,
      exceptToExcel: true,
    },
    {
      id: 'taxCode',
      numeric: true,
      disablePadding: false,
      label: 'VKN/TCKN',
      isRender: true,
      className: "min-w-[150px]",
      maxLength: 11,
      renderRow: (row) => {
        return (
          <div className="">
            {row.taxCode || row.tcCode}
          </div>
        );
      }
    },
    {
      id: 'customerCode',
      numeric: true,
      disablePadding: false,
      label: 'Cari Hesap Kodu',
      className: "min-w-[180px]",
      colWidth: 40, // For excel
      maxLength: 30
    },
    {
      id: 'sendTypeId',
      numeric: true,
      disablePadding: false,
      label: 'Link Gönderim Şekli',
      className: "min-w-[175px]",
      isRender: true,
      colWidth: 20, // For excel
      renderRow: (row) => {
        var text = getSendTypeDescHelper(row.sendTypeId);
        return (
          <div>
            {text}
          </div>
        );
      }
    },
    {
      id: 'vpDisplayName',
      numeric: true,
      disablePadding: false,
      label: 'Ödeme Altyapısı',
      className: "min-w-[155px]",
      maxLength: 15,
      colWidth: 20, // For excel
    },
    {
      id: 'orderResourceDesc',
      numeric: true,
      disablePadding: false,
      label: 'Ödeme Kaynağı',
      className: "min-w-[155px]",
      maxLength: 15,
      colWidth: 20, // For excel
    },
    {
      id: 'phone',
      numeric: true,
      disablePadding: false,
      label: 'Telefon',
      colWidth: 20, // For excel
      className: "min-w-[110px]",
      maxLength: 15,
    },
    {
      id: 'email',
      numeric: true,
      disablePadding: false,
      label: 'Email',
      className: "max-w-[220px]",
      maxLength: 30,
      colWidth: 30, // For excel
    },
    {
      id: 'cardOwner',
      numeric: true,
      disablePadding: false,
      label: 'İşlem Yapılan Kart',
      className: "min-w-[200px]",
      colWidth: 20, // For excel 
      maxLength: 30,
      isRender: true,
      renderRow: (row) => {

        var allDesc = getCardOwnerAllDescHelper(row);
        return (
          <div className="">
            {allDesc}
          </div>
        );
      }
    },
    {
      id: 'erpDocumentNo',
      disablePadding: false,
      label: 'ERP Fiş Numarası',
      className: "min-w-[170px]",
      maxLength: 20,
      isRender: true,
      renderRow: (row) => {

        return (
          <div className="">
            {row.erpDocumentNo || row.erpdocumentid}
          </div>
        );
      }
    },
    {
      id: "userDesc",
      disablePadding: false,
      label: "İşlem Yapan Kullanıcı",
      className: "max-w-[220px] min-w-[190px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true,
      isRender: true,
      renderRow: (row) => {
        return (
          <div className="">
            {row.userDesc ? row.userDesc : row.userName}
          </div>
        )
      }
    },
    {
      id: 'parentUserDescription',
      numeric: true,
      disablePadding: false,
      label: 'Bayi',
      className: "min-w-[360px]",
      maxLength: 30,
      colWidth: 30, // For excel
    },
    {
      id: 'syncCustomerDesc',
      numeric: true,
      disablePadding: false,
      label: 'Ödemenin Bağlı Olduğu Cari Hesap Ünvan',
      className: "min-w-[360px]",
      maxLength: 30,
      colWidth: 30, // For excel
    },
    {
      id: "nameOnCard",
      disablePadding: false,
      label: "Kart Üzerindeki İsim",
      className: "max-w-[220px] min-w-[180px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true,
      isRender: true,
      renderRow: (row) => {
        return (
          <div className="">
            {row.firstName + " " + row.lastName}
          </div>
        )
      }
    },
    {
      id: "authCode",
      disablePadding: false,
      label: "Onay Kodu",
      className: "max-w-[220px] min-w-[120px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
    },
    {
      id: 'netAmount',
      numeric: true,
      disablePadding: false,
      label: 'Komisyon Hariç Tutar',
      className: "min-w-[185px]",
      isMoney: true,
      maxLength: 15,
      colWidth: 20, // For excel
      isRender: true,
      renderRow: (row) => {
        return (
          <>
            {formatCurrency(parseFloat(row.firstAmount - row.commissionAmount)) + row.currencySymbol}
          </>
        )
      }
    },
    {
      id: "commissionAmount",
      disablePadding: false,
      isMoney: true,
      label: "Komisyon Tutarı",
      className: "max-w-[220px] min-w-[155px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      renderRow: (row) => {
        return (
          <>
            {formatCurrency(parseFloat(row.commissionAmount)) + row.currencySymbol}
          </>
        )
      }
    },
    {
      id: "city",
      disablePadding: false,
      label: "Şehir",
      className: "max-w-[220px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
    },
    {
      id: "orderDescription",
      disablePadding: false,
      label: "Ödeme Açıklaması",
      className: "max-w-[220px] min-w-[170px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
    },
    {
      id: "linkDesc",
      disablePadding: false,
      label: "Link Açıklaması",
      className: "max-w-[220px] min-w-[150px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
    },
    {
      id: "currencySymbol",
      disablePadding: false,
      label: "Para Birimi",
      className: "max-w-[220px] min-w-[120px]",
      forcealign: "center",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true,
      isRender: true,
      renderRow: (row) => {
        return (
          <div className="" >
            {row.currencySymbol === "₺" ? "TL (₺)" : row.currencySymbol === "€" ? "EURO (€)" : row.currencySymbol === "£" ? "GBP (£)" : "USD ($)"}
          </div>
        )
      }
    },
    {
      id: "transactionId",
      disablePadding: false,
      label: "Sipariş Kodu",
      className: "max-w-[220px] min-w-[130px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
    },
    {
      id: "clientIp",
      disablePadding: false,
      label: "IP",
      className: "max-w-[220px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
    },
    {
      id: "cardMask",
      disablePadding: false,
      label: "Maskeli Kart Bilgisi",
      className: "max-w-[250px] min-w-[175px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      renderRow: (row) => {
        const cardInfo = row.cardBank + "*******" + row.cardMask;

        return (
          <div className="">
            {cardInfo.replace(/\s/g, '')}
          </div>
        )
      }
    },
    {
      id: 'invoiceNumber',
      numeric: false,
      disablePadding: false,
      label: 'Fatura Numarası ',
      className: "min-w-[180px]",
      isMoney: false,
      maxLength: 15,
    },
    {
      id: 'gibInvoiceNumber',
      numeric: false,
      disablePadding: false,
      label: 'Gib Fat. Numarası ',
      className: "min-w-[180px]",
      isMoney: false,
      maxLength: 15,
    },
    {
      id: "orderTrackingCode",
      disablePadding: false,
      label: "Sipariş Takip Numarası",
      className: "max-w-[220px] min-w-[200px]",
      maxLength: 30,
      colWidth: 30,
      hide: false
    },
  ];

  function LinearColor() {
    if ((operationsLoading || isloadingIntegration)) {
      return (
        // <Stack sx={{ width: '100%', color: 'grey.500', alignItems: "center" }} spacing={2}>

        //   <LinearProgress color="primary" sx={{ width: "95%" }} />
        // </Stack>
        <ProgressLoader />
      );
    }
  }
  return (
    <>
      {LinearColor()}
      <ConfirmationModal ref={confirmModalRef}></ConfirmationModal>
      <RefundModal ref={refundModalRef} />
      <MaterailTable ref={reportTableRef} headerCells={headCells} tableData={reports} isRowSelect isLoading={loading}
        isError={isError} emptyMessage={isfetchComplete ? "Verilen kritere uygun kayıt bulunamamıştır" : ""} totalParameter="firstAmount" totalLabel="Tutar"
      ></MaterailTable>
      <PaymentSlipModal ref={paymentSlipModalRef} isLoading={isLoading} setIsLoading={setIsLoading}></PaymentSlipModal>

      <IntegrationResultModal ref={integratrionResultModalRef} statusModalVisible={integrationResultModalVisible} setStatusModalVisible={setIntegrationResultModalVisible}></IntegrationResultModal>
      <StatusModal ref={resultStatusModalRef}>

      </StatusModal>
    </>
  );
}
